import { Button } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import {
  auditColumnDefs,
  columnDefs as gridcolDef,
  defaultDisableButtonsObject,
  fields,
  status as questionStatuses,
  status_colors
} from '../constants/QuestionBankConstants';
import {
  apiPaths,
  deleteData,
  get, postData
} from '../platform-components/api-integration-util';
import { Chart } from '../platform-components/Chart';
import Grid from '../platform-components/grid/Grid';
import { PreLoader } from '../platform-components/PreLoader';
import { Toaster } from '../platform-components/Toaster';
import { setItemToStorage } from '../platform-components/utils/common-utils';
import {
  checkPermission,
  setEditQuestion
} from '../platform-components/utils/configuration';
import {
  getRoleNameList, setclickedParamsForAudit
} from '../platform-components/utils/shared-data.service';
import { setQuestionIds } from './Dashboard-Service';
import './dashboard.scss';

function Dashboard(props) {
  let [chartsData, setChartsData] = useState({});
  let [displayCharts, setDisplayCharts] = useState(false);
  let [selectedNodes, setSelectedNodes] = useState([]);
  let [displayAudit, setDisplayAudit] = useState(false);
  let [displayComments, setDisplayComments] = useState(false);
  let [prev, setPrev] = useState(true);
  let comments;
  let data = {
    data: [
      {
        values: [],
        labels: [],
        type: 'pie',
      },
    ],
    layout: {
      // autosize: true,
      margin: { t: 30, l: 0, r: 0, b: 30 },
      // padding: { t: 0, l: 10, r: 0, b: 0 },
      // height: 200,
      // width: 200,
      legend: {
        font: {
          family: 'sans-serif',
          size: 15,
          color: '#000',
        },
      },
    },
  };
  // let gridOptions = {};
  let gridApi = useRef();
  let status = useRef();
  let auditGridApi = useRef();
  let [loading, setLoading] = useState(true);
  let [gridOptions, setGridOptions] = useState({});
  let [auditGridOptions, setAuditGridOptions] = useState({});
  let [disableButtons, setDisableButtons] = useState(
    JSON.parse(JSON.stringify(defaultDisableButtonsObject))
  );
  let [displayErroMessagePopup, setDisplayErroMessagePopup] = useState(false);

  const [selectedStatuses, setSelectedStatuses] = useState(
    () =>
      JSON.parse(localStorage.getItem('selectedStatuses')) ||
      Object.keys(questionStatuses)
        .map((el) => el)
        .filter((fl) => fl !== 'APPROVED') || []
  );

  const handleStatusClick = (status) => {
  if (selectedStatuses.includes(status)) {
    // unselect the status if it's already selected
    setSelectedStatuses(
      selectedStatuses.filter(
        (selectedStatus) => selectedStatus !== status
      )
    );
  } else {
    // select the status if it's not already selected
    setSelectedStatuses([...selectedStatuses, status]);
  }
};

useEffect(() => {
  localStorage.setItem('selectedStatuses', JSON.stringify(selectedStatuses));
}, [selectedStatuses]);


  const link = (params) => {
    return (
      <div className='text-link' onClick={() => nav(params?.value, params)}>
        {params?.value}
      </div>
    );
  };
  const onAuditClick = (questionId, tenantId, params) => {
    setclickedParamsForAudit(params);
   
    get(apiPaths.questionstatusaudit, { questionId, tenantId })
      .then((res) => {
        if (res?.result) {
          Toaster(toast.TYPE.SUCCESS, 'Audit Retrieved Successfully');
          auditGridOptions.columnDefs = auditColumnDefs;
          res.result.sort((e1, e2) => e2.auditId - e1.auditId);
          auditGridOptions.rowData = res?.result;
          auditGridOptions.paginationPageSize = 20;
          auditGridOptions.pagination = true;
          auditGridOptions.domLayout = '';
          auditGridOptions.onGridReady = (params) => {
            auditGridApi.current = params.api;
          };
          setTimeout(() => auditGridApi?.current?.setRowData(res?.result));
          setDisplayAudit(true);
        }
      })
      .catch((ele) => {
        Toaster(toast.TYPE.SUCCESS, 'Error while retrieving audit data');
      });
    
  };
  const button = (params) => {
    return (
      <div
        onClick={() => {
          setDisplayComments(false);
          onAuditClick(params?.data.questionId, params.data.tenantId, params);
        }}
      >
        <button
          data-toggle='modal'
          data-target='#myModal'
          type='button'
          value='Audit'
          style={{ 'margin-right': '10px' }}
        >
          Audit
        </button>
      </div>
    );
  };
  useEffect(() => {
    getDashboardGraphData();
    setItemToStorage('qbData', {})
  }, []);

  const prepareChrtObj = (res, name) => {
    let chartObj = JSON.parse(JSON.stringify(data));
    chartObj.data[0].values = res.map(type => type.count);
    chartObj.data[0].labels = res.map(type => type.name ? type.name : 'No Value');
    chartObj.layout['title'] = `<b>${name} </b>`;
    setChartsData((prev) => {
      prev[name] = chartObj;
      return prev;
    });
  };
  const onAuditClose = () => {
    setDisplayAudit(false);
  };

  const getDashboardGraphData = () => {
    // let requestparam = {admin: false};
    let requestparam = {};
    let role = getRoleNameList();
    // if (role === 'Admin') {
    //   requestparam.admin = true;
    // }
    setDisplayCharts(false);
    postData(apiPaths.dashboardGraph, { data: [], params: requestparam })
    .then((data) => {
        if(data.result && data.result.viewByStatus) {
          prepareChrtObj(data.result.viewByStatus, 'Status');
        }
        // if(data.result && data.result.viewBySubject) {
        //   prepareChrtObj(data.result.viewBySubject, 'Subject');
        // }
        if(data.result && data.result.viewByUpdatedBy) {
            prepareChrtObj(data.result.viewByUpdatedBy, 'Updated By');
        }
        if(data.result && data.result.viewByComplexity) {
          prepareChrtObj(data.result.viewByComplexity, 'Complexity');
        }
        if(data.result && data.result.viewByCreatedBy) {
          prepareChrtObj(data.result.viewByCreatedBy, 'Created By');
        }

        setTimeout(() => {
          let len = Object.getOwnPropertyNames(chartsData).length;
          let expectedLen = role.includes('Admin') ? 1 : 3;
          if (len >= expectedLen) {
          }

        });
    });
  }

  useEffect(() => {
    getQuestions()
  }, [selectedStatuses])

  const getQuestions = () => {
    postData(apiPaths.questionslist, {
      data: selectedStatuses.map((el) => {
        if(el === 'SENT_FOR_APPROVAL') {
          return 'SENT FOR APPROVAL'
        }
        if(el === 'CORRECTION_NEEDED') {
          return 'NEED CORRECTION'
        } 
        return el
      }),
      params: { },
    })
      .then((res) => {
        let rowData = res?.result || [];
        rowData.sort((e1, e2) => e2?.questionId - e1?.questionId);
        
        setTimeout(() => gridApi?.current?.setRowData(rowData));
        gridOptions.rowSelection = 'multiple';
        gridOptions.columnDefs = columnDefs;
        gridOptions.rowData = rowData;

        gridOptions.paginationPageSize = 20;
        gridOptions.pagination = true;
        gridOptions.domLayout = '';
        gridOptions.suppressRowClickSelection = true;

        gridOptions.onGridReady = (params) => {
          gridApi.current = params.api;
        };
        gridOptions.onSelectionChanged = (params) => {
          setSelectedNodes(
            params.api.getSelectedRows().map((e) => e?.questionId)
          );
          isValidUpdate(params.api.getSelectedRows());
        };
        gridOptions.onFirstDataRendered =  (params) => {
          // add listener to header checkbox
          var headerCheckbox = document.querySelector('.ag-checkbox');
          if(headerCheckbox) {
            headerCheckbox.addEventListener('click', function () {
              var selectedRows = [];
              console.log('selectedRows: ', selectedRows);
              gridApi.current.forEachNode(function (node) {
                if (node.rowIndex >= gridApi.current.paginationGetCurrentPage() * gridOptions.paginationPageSize
                  && node.rowIndex < (gridApi.current.paginationGetCurrentPage() + 1) * gridOptions.paginationPageSize) {
                  selectedRows.push(node);
                }
              });
              gridApi.current.deselectAll();
              selectedRows.forEach(function (node) {
                node.setSelected(true);
              });
            });
          }
        }
        gridOptions.suppressRowDeselection = true
        gridOptions.isRowSelectable = (params) =>
          params.data.questionStatus !== 'APPROVED';
        setGridOptions(gridOptions);
        setLoading(false);
      })
      .catch((err) => setLoading(false));
  };

  let columnDefs = gridcolDef;
  gridcolDef.forEach((ele) => {
    if (ele?.field === fields.QUESTION_ID) {
      ele.cellRendererFramework = link;
      ele.cellStyle = (params) => {
        let obj = { background: '', color: 'black' };
        switch (params.data.questionStatus) {
          case questionStatuses.APPROVED:
            obj.background = '#19D2AC';
            return obj;
          case questionStatuses.SENT_FOR_APPROVAL:
            obj.background = 'yellow';
            return obj;
          case questionStatuses.SAVED:
            obj.background = obj.background = 'grey';
            return obj;
          case questionStatuses.CORRECTION_NEEDED:
            obj.background = '#FFB347';
            return obj;
          case questionStatuses.REJECTED:
            obj.background = '#ED3817';
            return obj;
          default:
            return {};
        }
      };
    }
    if (ele?.headerName === fields.ACTIONS) {
      ele.cellRendererFramework = button;
    }
  });

  const deleteQuestion = () => {
    deleteData(apiPaths.delete, {
      data: selectedNodes,
    })
      .then((res) => {
        setDisableButtons(
          JSON.parse(JSON.stringify(defaultDisableButtonsObject))
        );
        getQuestions();
      })
      .catch((err) => console.log(err));
  };
  const isValidUpdate = (rows) => {
    if (rows.length == 0) {
      setDisableButtons(
        JSON.parse(JSON.stringify(defaultDisableButtonsObject))
      );
      return;
    }
    Object.keys(questionStatuses).forEach((qs) => {
      switch (questionStatuses[qs]) {
        case questionStatuses.SENT_FOR_APPROVAL:
          let invalidRowIds1 = rows
            .filter(
              (ele) => ele.questionStatus == questionStatuses.SENT_FOR_APPROVAL
            )
            .map((ele) => ele.questionId);
          let Message1 =
            'Questions[' +
            invalidRowIds1.join(',') +
            '] which are in Sent For Approval cannot be Sent For Approval';

          setDisableButtons((prev) => {
            let a = {};
            a[questionStatuses[qs]] = prev[questionStatuses[qs]];
            a[questionStatuses[qs]]['disable'] = invalidRowIds1.length != 0;
            a[questionStatuses[qs]]['Message'] = a[questionStatuses[qs]][
              'disable'
            ]
              ? Message1
              : '';
            return { ...prev, ...a };
          });
          break;
        case questionStatuses.APPROVED:
        case questionStatuses.CORRECTION_NEEDED:
        case questionStatuses.REJECTED:
          let invalidRowIds2 = rows
            .filter(
              (ele) => ele.questionStatus !== questionStatuses.SENT_FOR_APPROVAL
            )
            .map((ele) => ele.questionId);
          let Message2 =
            'Questions[' +
            invalidRowIds2.join(',') +
            '] which are not in Sent For Approval cannot be updated as ' +
            questionStatuses[qs];
          setDisableButtons((prev) => {
            let a = {};
            a[questionStatuses[qs]] = prev[questionStatuses[qs]];
            a[questionStatuses[qs]]['disable'] = invalidRowIds2.length != 0;
            a[questionStatuses[qs]]['Message'] = a[questionStatuses[qs]][
              'disable'
            ]
              ? Message2
              : '';
            return { ...prev, ...a };
          });
          break;
        default:
          return;
      }
    });
  };
  const updateQuestionStatus = (val) => {
    if (selectedNodes.length === 0) return;

    setDisplayAudit(false);
    setDisplayComments(true);
    status.current = val;
  };
  const onClickNav = (btn) => {
    setPrev(btn !== 'next');
  };
  const onClickCommentsOk = () => {
      postData(apiPaths.updateQuestionStatus, {
        data: {
          "comment": comments && comments.length > 0  ? comments : '',
          "newStatus": status.current,
          "questionId": selectedNodes
        },
      })
      .then((val) => {
        comments = '';
        setDisplayComments(false);
        setSelectedNodes([]);
        setDisableButtons(
          JSON.parse(JSON.stringify(defaultDisableButtonsObject))
        );
        getQuestions();
      })
      .catch((err) => setDisplayComments(false));
  };
  const nav = (id, params) => {
    setEditQuestion(
      checkPermission('addQuestion') &&
        params?.data?.questionStatus !== 'APPROVED'
    );
    if (id !== 0) {
      setQuestionIds(gridOptions.rowData.map((ele) => ele.questionId));
    }
    sessionStorage.setItem('routeFrom', 'dashboard')
    props.history.push('/app/question/' + id);
  };

  return loading ? (
    <PreLoader />
  ) : (
    <div className='dashboard-main-div'>
      <div className='main-heading'>Dashboard</div>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <Button
          variant="text"
          style={{ marginBottom: "2px" }}
          onClick={() => setDisplayCharts(!displayCharts)}
        >
          {" "}
          {displayCharts ? "hide" : "show"} chart
        </Button>
        </div>
      {displayCharts ? (
          prev ? (
            <span key='subSta' className='chartsdiv-main'>
              <div className='charts-div' key='StatusSubject'>
                {chartsData['Status']
                  ? Chart(chartsData['Status'])
                  : ''}
                {chartsData['Updated By']
                  ? Chart(chartsData['Updated By'])
                  : ''}
              </div>
              <button
                className='btn-common-circle btn-common-circle-right'
                onClick={() => onClickNav('next')}
              >
                <i class='fa fa-chevron-right'></i>
              </button>
            </span>
          ) : (
            <span key='crecomp' className='chartsdiv-main'>
              <div className='charts-div' key='CreatedComplex'>
                {chartsData['Complexity']
                  ? Chart(chartsData['Complexity'])
                  : ''}
                {chartsData['Created By']
                  ? Chart(chartsData['Created By'])
                  : ''}
              </div>
              <button
                className='btn-common-circle btn-common-circle-left'
                onClick={() => onClickNav('prev')}
              >
                <i class='fa fa-chevron-left'></i>
              </button>
            </span>
          )
        ) : (
        <span
          key='subSta'
          className=''
          // style={{ height: '170px' }}
        >
          {/* <PreLoader /> */}
        </span>
      )}

      <div className='background-common-div'>
        <div className='btn-div'>
          <div style={{ display: 'flex', paddingTop: '5px', float: 'left' }}>
          {Object.keys(questionStatuses).map((ele) => (
        <div
          key={ele}
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '8px',
            cursor: 'pointer',
          }}
          onClick={() => handleStatusClick(ele)}
        >
          <span
            style={{
              background: status_colors[ele],
              border: '1px solid #000',
              height: '16px',
              width: '16px',
              display: 'inline-block',
            }}
          >
            {selectedStatuses.includes(ele) && (
            <span style={{ marginLeft: '0px' }}>✓</span>
          )}
          </span>
          <span
            style={{
              background: 'white',
              borderRadius: '22px',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              paddingRight: '4px',
              display: 'inline-block',
              paddingLeft: '2px',
              marginLeft: '8px',
            }}
            title={questionStatuses[ele]}
          >
            {questionStatuses[ele]}
          </span>
        </div>
      ))}
          </div>
          <div style={{ paddingTop: '5px', float: 'right' }}>
            {checkPermission('addQuestion') && (
              <button className='btn-common' onClick={() => nav(0)}>
                Add Question
              </button>
            )}
            {checkPermission('uploadQuestion') && (
              <button className='btn-common' onClick={() =>     props.history.push('/app/file/upload/0') }>
                Upload Question
              </button>
            )}
            {checkPermission('sendForApproval') && (
              <button
                className='btn-common'
                onClick={() =>
                  updateQuestionStatus(questionStatuses.SENT_FOR_APPROVAL)
                }
                disabled={
                  disableButtons[questionStatuses.SENT_FOR_APPROVAL].disable
                }
                title={disableButtons[questionStatuses.SENT_FOR_APPROVAL].Message}
                data-toggle='modal'
                data-target='#myModal'
              >
                Send for Approval
              </button>
            )}
            {checkPermission('approve') && (
              <button
                className='btn-common'
                data-toggle='modal'
                data-target='#myModal'
                onClick={() => updateQuestionStatus(questionStatuses.APPROVED)}
                disabled={disableButtons[questionStatuses.APPROVED].disable}
                title={disableButtons[questionStatuses.APPROVED].Message}
              >
                Approve
              </button>
            )}
            {checkPermission('correctionNeeded') && (
              <button
                className='btn-common'
                onClick={() =>
                  updateQuestionStatus(questionStatuses.CORRECTION_NEEDED)
                }
                disabled={
                  disableButtons[questionStatuses.CORRECTION_NEEDED].disable
                }
                title={disableButtons[questionStatuses.CORRECTION_NEEDED].Message}
                data-toggle='modal'
                data-target='#myModal'
              >
                Correction Needed
              </button>
            )}
            {checkPermission('rejected') && (
              <button
                className='btn-common'
                onClick={() => updateQuestionStatus(questionStatuses.REJECTED)}
                disabled={disableButtons[questionStatuses.REJECTED].disable}
                title={disableButtons[questionStatuses.REJECTED].Message}
                data-toggle='modal'
                data-target='#myModal'
              >
                Reject
              </button>
            )}
            {checkPermission('deleteQuestion') && (
              <button
                className='btn-common'
                onClick={deleteQuestion}
                disabled={selectedNodes.length === 0}
              >
                Delete
              </button>
            )}
          </div>
        </div>
        
        <div className='common-div-alt'>
          <Grid gridOptions={gridOptions} parent="dashboard"/>
        </div>
      </div>

      <div
          id='myModal'
          class='modal fade show'
          role='dialog'
          style={{ display: displayComments || displayAudit ? 'block' : '' }}
        >
          <div class='modal-dialog modal-dialog-custom'>
            <div class='modal-content'>
              <div class='modal-header modal-header-custom'>
                <button
                  type='button'
                  class='close'
                  data-dismiss='modal'
                  onClick={() => {
                    setDisplayComments(false);
                    setDisplayAudit(false);
                  }}
                >
                  <div class='close-btn'>
                    <i class='fa fa-close' aria-hidden='true'></i>
                  </div>
                </button>
              </div>
              <div class='modal-body modal-body-custom'>
                {displayComments ? (
                  <div class='comments-div'>
                    <div class='comments-text-div'>Add comments</div>
                    <textarea
                      class='textarea-custom'
                      onChange={($event) => (comments = $event.target.value)}
                      value={comments}
                    ></textarea>
                    <button
                      class='btn-common float-right'
                      onClick={() => onClickCommentsOk()}
                      data-dismiss='modal'
                    >
                      OK
                    </button>
                  </div>
                ) : (
                  ''
                )}
                {displayAudit ? (
                  <div style={{height: '100%'}}>
                    <Grid gridOptions={auditGridOptions} parent="dashboard" />
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </div>
    </div>
  );
}

export default Dashboard;
